module.exports = __webpack_public_path__ + "static/media/sf-test-17.3523538e.mp3";